/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

import { isProd } from './lib/constants'

const region = process.env.REACT_APP_AWS_REGION || 'eu-west-2'
const userPoolId = process.env.REACT_APP_AWS_POOL_ID || 'eu-west-2_PUcAP2ljU'
const clientId =
    process.env.REACT_APP_AWS_CLIENT_ID || '25bnl2nnrrvsg349bf600j9s73'

// prettier-ignore
const awsConfig = {
    "aws_project_region": region,
    "aws_cognito_region": region,
    "aws_user_pools_id": userPoolId,
    "aws_user_pools_web_client_id": clientId,
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": []
};

// prettier-ignore
const awsConfigTest = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_PUcAP2ljU",
    "aws_user_pools_web_client_id": "25bnl2nnrrvsg349bf600j9s73",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": []
};
// "aws_user_pools_web_client_id": "130h4kah0lf1kladn2tatbv7a6",
// "aws_user_pools_web_client_id": "4gmutfot3m7u4hhafjjrfbiei4",
// "aws_user_pools_web_client_id": "130h4kah0lf1kladn2tatbv7a6",

const awsConfigProd = {
    aws_project_region: 'eu-north-1',
    aws_cognito_region: 'eu-north-1',
    aws_user_pools_id: 'eu-north-1_y9RkrZ3vD',
    aws_user_pools_web_client_id: '4gmutfot3m7u4hhafjjrfbiei4',

    oauth: {},
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OFF',
    aws_cognito_mfa_types: [],
    aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [
            'REQUIRES_LOWERCASE',
            'REQUIRES_UPPERCASE',
            'REQUIRES_NUMBERS',
        ],
    },
    aws_cognito_verification_mechanisms: [],
}
export default isProd ? awsConfigProd : awsConfig
